<template>
  <dt-modal v-model="value" class="wide-modal">
    <div slot="header">
      <h4 class="modal-title">
        📅 {{ isHolidayHours ? $t('dialog.header.holidayopeninghours') : $t('dialog.header.standardopeninghours') }}
      </h4>
    </div>
    <div slot="body">
      <p class="centered-text">{{ $t('dialog.body.openinghours') }}</p>
      <p></p>
      <holiday-opening-hours v-if="isHolidayHours" :holidayHours="openingHours" />
      <standard-opening-hours v-else :standardHours="openingHours" />
      <p></p>
      <p class="note centered-text">{{ $t('dialog.body.openinghours.supportemail') }} <strong>{{ supportEmail }}</strong></p>
    </div>

    <div slot="footer">
      <button type="button" class="btn btn-primary" @click="close">
        {{ $t('popup.close') }}
      </button>
    </div>
  </dt-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import DtModal from '@/components/utilities/modal/dt-modal.vue'
import HolidayOpeningHours from '@/components/openinghours/holiday-opening-hours.vue'
import StandardOpeningHours from '@/components/openinghours/standard-opening-hours.vue'

export default {
  name: 'dialog-opening-hours',
  components: {
    DtModal,
    HolidayOpeningHours,
    StandardOpeningHours
  },
  props: {
    value: Boolean,
    supportEmail: String
  },
  computed: {
    ...mapGetters('openingHours', ['openingHours']),

    // Compute the type of opening hours (holiday vs standard)
    isHolidayHours() {
      return (
        Array.isArray(this.openingHours) &&
        this.openingHours.length > 0 &&
        this.openingHours[0] !== null &&
        this.openingHours[0] !== undefined &&
        typeof this.openingHours[0] === 'object' &&
        'scheduledDate' in this.openingHours[0]
      )
    }
  },
  methods: {
    close() {
      this.$emit('closing')
    }
  }
}
</script>

<style lang="scss" scoped>
.wide-modal {
  max-width: 1000px !important;
}
.note {
  margin-top: 10px;
  font-style: italic;
}
.centered-text {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/openinghours/dialog-opening-hours.vue